import { render, staticRenderFns } from "./ConsultationList.vue?vue&type=template&id=f239cc50&scoped=true"
import script from "./ConsultationList.vue?vue&type=script&lang=js"
export * from "./ConsultationList.vue?vue&type=script&lang=js"
import style0 from "./ConsultationList.vue?vue&type=style&index=0&id=f239cc50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f239cc50",
  null
  
)

export default component.exports